import type { SelectFieldOption } from '@hrlogics/react-helper-types';

import type { Nullable } from '@clearverify/types';

import type { AddressFieldsFormFields } from 'src/constants/address';

export const PeoCompanyInformationFormFields = {
  displayName: 'displayName',
  fein: 'fein',
  corporateStructure: 'corporateStructure',
  industry: 'industry',
  taxYearEndDate: 'taxYearEndDate',
  numberOfEmployees: 'numberOfEmployees',
  contactPhoneNumber: 'contactPhoneNumber',
  contactEmail: 'contactEmail',
  defaultDisclaimer: 'defaultDisclaimer',
  headquarters: 'headquarters',
} as const;

export type PeoCompanyInformationFormValues = {
  [PeoCompanyInformationFormFields.displayName]: string;
  [PeoCompanyInformationFormFields.fein]: string;
  [PeoCompanyInformationFormFields.corporateStructure]?: Nullable<string>;
  [PeoCompanyInformationFormFields.industry]?: Nullable<SelectFieldOption>;
  [PeoCompanyInformationFormFields.taxYearEndDate]?: Nullable<string>;
  [PeoCompanyInformationFormFields.numberOfEmployees]?: Nullable<number>;
  [PeoCompanyInformationFormFields.contactPhoneNumber]?: Nullable<string>;
  [PeoCompanyInformationFormFields.contactEmail]: string;
  [PeoCompanyInformationFormFields.defaultDisclaimer]?: Nullable<string>;
  [PeoCompanyInformationFormFields.headquarters]: Nullable<{
    [AddressFieldsFormFields.street]: string;
    [AddressFieldsFormFields.city]: string;
    [AddressFieldsFormFields.county]?: Nullable<string>;
    [AddressFieldsFormFields.state]: string;
    [AddressFieldsFormFields.zipCode]: string;
  }>;
};
